import React, { useEffect } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import TabContent from "rc-tabs/lib/SwipeableTabContent";
import ScrollableInkTabBar from "rc-tabs/lib/ScrollableInkTabBar";
import TabCollaborationPolicy from "./Tabs/TabCollaborationPolicy";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import Tabs, { TabPane } from "rc-tabs";
import { useQuery } from "@apollo/client";
import { useUserEmail } from "../../../Layout/AppMain/LoginStatusContext";
import { QUERY_ALL_USER } from "../../../queries";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  NavItem,
  Nav,
  NavLink,
} from "reactstrap";
import classnames from "classnames";
import TabGetStarted from "./Tabs/TabGetStarted";
import CSOPartnershipTable from "./Table/CSOPartnershipTable";
import SearchCSO from "./SearchCSO";
import CompareCSO from "./CompareCSO";
import MessageList from "./MessageList";
import WishesCSO from "./MessageList/Wishes.jsx";
import IndexCSO from "./MessageList/IndexCSO";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./organization-partnership.css";

const OrganizationPartnership = () => {
  const location = useLocation();
  // const query = new URLSearchParams(location.search);
  let tabActive =
    localStorage.getItem("tabActive") !== null
      ? localStorage.getItem("tabActive")
      : "1";
  // const [ tabActive, setTabActive ] = useState(localStorage.getItem("tabActive"))
  const user = useQuery(QUERY_ALL_USER, {
    variables: { email: useUserEmail() },
  });
  const isSupporter = user?.data?.allUsers?.edges[0]?.node?.isSupporter;
  const [activeKey, setActiveKey] = useState(tabActive);

  const handleChangeTab = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    if (localStorage.getItem("tabActive") !== null) {
      const tab = localStorage.getItem("tabActive");
      if (user?.data?.allUsers?.edges[0]?.node?.isSupporter) {
        localStorage.setItem("tabActive", tab);
      } else {
        localStorage.setItem("tabActive", "1");
      }
    } else {
      localStorage.setItem("tabActive", "1");
    }
  }, []);

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear={true}
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      {user?.loading && (
        <div className="loading__wrapper">
          <img
            alt=""
            style={{ width: "80px", margin: "auto" }}
            src={animetionLogo}
          />
        </div>
      )}

      {!user?.loading && !user?.error && (
        <Row>
          <Col md="12">
            <Card className="main-card">
              <CardBody style={{ padding: "30px" }}>
                <CardHeader
                  style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    color: "#353A3F",
                    padding: "0px",
                    height: "min-content",
                    paddingBottom: "16px",
                    lineHeight: "100%",
                  }}
                >
                  パートナーシップ
                </CardHeader>
                {activeKey === "2" &&
                  user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                    <a
                      href="/#/dashboards/plofile-organization"
                      className="button-redirect"
                      style={{
                        position: "absolute",
                        top: "85px",
                        right: "30px",
                        border: "1px solid #44CAE1",
                        borderRadius: "50px",
                        padding: "7px 11px",
                        backgroundColor: "transparent",
                        color: "#44CAE1",
                        zIndex: 999,
                      }}
                      onClick={() => {
                        localStorage.setItem("tab", "2");
                      }}
                      target="_blank"
                    >
                      編集はこちら
                    </a>
                  )}
                {activeKey === "2" &&
                  !user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                    <a
                      href="/#/dashboards/plofile-organization"
                      className="button-redirect"
                      style={{
                        position: "absolute",
                        top: "85px",
                        right: "30px",
                        border: "1px solid #44CAE1",
                        borderRadius: "50px",
                        padding: "7px 11px",
                        backgroundColor: "transparent",
                        color: "#44CAE1",
                        zIndex: 999,
                      }}
                      onClick={() => {
                        localStorage.setItem("tab", "2");
                      }}
                      target="_blank"
                    >
                      編集はこちら
                    </a>
                  )}

                <div
                  style={{
                    marginTop: "12px",
                    flexDirection: "column",
                  }}
                  className="menu-tab-responsive"
                >
                  <button
                    style={{
                      backgroundColor:
                        activeKey === "1" ? "#44CAE1" : "#EBECED",
                      color: activeKey === "1" ? "white" : "#303030",
                      borderBottom:
                        activeKey === "1" ? "2px solid #44CAE1" : "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderTop: "none",
                      marginBottom: "8px",
                      textAlign: "left",
                      paddingBottom: "2px",
                      paddingTop: "2px",
                      borderRadius: "4px",
                    }}
                    onClick={() => handleChangeTab("1")}
                  >
                    はじめに
                  </button>
                  <button
                    style={{
                      backgroundColor:
                        activeKey === "2" ? "#44CAE1" : "#EBECED",
                      color: activeKey === "2" ? "white" : "#303030",
                      borderBottom:
                        activeKey === "2" ? "2px solid #44CAE1" : "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderTop: "none",
                      marginBottom: "8px",
                      textAlign: "left",
                      paddingBottom: "2px",
                      paddingTop: "2px",
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      handleChangeTab("2");
                    }}
                  >
                    連携方針を確認する
                  </button>
                  {user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                    <button
                      style={{
                        backgroundColor:
                          activeKey === "3" ? "#44CAE1" : "#EBECED",
                        color: activeKey === "3" ? "white" : "#303030",
                        borderBottom:
                          activeKey === "3" ? "2px solid #44CAE1" : "none",
                        borderRight: "none",
                        borderLeft: "none",
                        borderTop: "none",
                        marginBottom: "8px",
                        textAlign: "left",
                        paddingBottom: "2px",
                        paddingTop: "2px",
                        borderRadius: "4px",
                      }}
                      onClick={() => handleChangeTab("3")}
                    >
                      {/* 3 */}
                      連携先CSOを探す
                    </button>
                  )}
                  {user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                    <button
                      style={{
                        backgroundColor:
                          activeKey === "4" ? "#44CAE1" : "#EBECED",
                        color: activeKey === "4" ? "white" : "#303030",
                        borderBottom:
                          activeKey === "4" ? "2px solid #44CAE1" : "none",
                        borderRight: "none",
                        borderLeft: "none",
                        borderTop: "none",
                        marginBottom: "8px",
                        textAlign: "left",
                        paddingBottom: "2px",
                        paddingTop: "2px",
                        borderRadius: "4px",
                      }}
                      onClick={() => handleChangeTab("4")}
                    >
                      {/* 4 */}
                      CSOを比較する
                    </button>
                  )}
                  {user?.data?.allUsers?.edges[0]?.node?.isSupporter ? (
                    <button
                      style={{
                        backgroundColor:
                          activeKey === "5" ? "#44CAE1" : "#EBECED",
                        color: activeKey === "5" ? "white" : "#303030",
                        borderBottom:
                          activeKey === "5" ? "2px solid #44CAE1" : "none",
                        borderRight: "none",
                        borderLeft: "none",
                        borderTop: "none",
                        marginBottom: "8px",
                        textAlign: "left",
                        paddingBottom: "2px",
                        paddingTop: "2px",
                        borderRadius: "4px",
                      }}
                      onClick={() => handleChangeTab("5")}
                    >
                      {/* 5 */}
                      CSOにメッセージを送る
                    </button>
                  ) : (
                    <button
                      style={{
                        backgroundColor:
                          activeKey === "6" ? "#44CAE1" : "#EBECED",
                        color: activeKey === "6" ? "white" : "#303030",
                        borderBottom:
                          activeKey === "6" ? "2px solid #44CAE1" : "none",
                        borderRight: "none",
                        borderLeft: "none",
                        borderTop: "none",
                        marginBottom: "8px",
                        textAlign: "left",
                        paddingBottom: "2px",
                        paddingTop: "2px",
                        borderRadius: "4px",
                      }}
                      onClick={() => handleChangeTab("3")}
                    >
                      {/* 3 */}
                      メッセージ
                    </button>
                  )}
                </div>
                <Tabs
                  defaultActiveKey={activeKey}
                  renderTabBar={() => <ScrollableInkTabBar />}
                  renderTabContent={() => <TabContent />}
                  className="rc-tabs-organization-partnership"
                  onChange={(key) => {
                    setActiveKey(key);
                  }}
                  activeKey={String(activeKey)}
                >
                  <TabPane tab="はじめに" key="1">
                    <TabGetStarted
                      isSupporter={isSupporter}
                      setActiveKey={setActiveKey}
                      activeKey={activeKey}
                    />
                  </TabPane>
                  <TabPane tab="連携方針を確認する" key="2">
                    <TabCollaborationPolicy activeKey={activeKey} />
                  </TabPane>
                  {user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                    <TabPane tab="連携先CSOを探す" key="3">
                      <SearchCSO activeKey={activeKey} />
                    </TabPane>
                  )}
                  {user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                    <TabPane tab="CSOを比較する" key="4">
                      <CompareCSO activeKey={activeKey} />
                    </TabPane>
                  )}
                  {user?.data?.allUsers?.edges[0]?.node?.isSupporter ? (
                    <TabPane tab="CSOにメッセージを送る" key="5">
                      <WishesCSO />

                      <MessageList activeKey={activeKey} />
                    </TabPane>
                  ) : (
                    <TabPane tab="メッセージ" key="3">
                      <IndexCSO activeKey={activeKey} />
                    </TabPane>
                  )}
                </Tabs>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      {isSupporter && String(activeKey) !== "5" ? (
        <Row
          style={{
            marginTop: "50px",
          }}
        >
          <Col md="12">
            <Card className="main-card">
              <CardBody style={{ padding: "30px" }}>
                <CardHeader
                  style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    color: "#353A3F",
                    padding: "0px",
                    height: "min-content",
                    paddingBottom: "16px",
                    lineHeight: "100%",
                  }}
                >
                  CSO連携リスト
                </CardHeader>

                <CSOPartnershipTable activeKey={activeKey} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      ) : null}
    </CSSTransitionGroup>
  );
};

export default OrganizationPartnership;
